<template>
  <div class="ts-app-shell_fh">
    <div ref="container" class="padd-main">
      <div style="margin-top: 20px;">
        <el-row :gutter="24">
          <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24">
            <h6>
              <strong class="mobile-menu">
                Staff Connections
                <el-dropdown trigger="click">
                  <i
                    class="fas fa-ellipsis-v"
                    style="font-size: 24px; margin-left: 20px;"
                  ></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="el-dropdown-menu__item"
                      ><span @click="goBack">Back</span></el-dropdown-item
                    >
                    <el-dropdown-item class="el-dropdown-menu__item"
                      ><span @click="manageAssignedCaseworkers"
                        >Confirm Staff
                        <span class="req-notif">
                          {{ this.caseworkerToManage.length }}</span
                        ></span
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </strong>
            </h6>
          </el-col>
          <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
            <div class="ts-app-shell--header_actions flexed">
              <span style="font-size:16px"><b>Staff:</b></span
              >&nbsp;&nbsp;<span style="color:#00C8DC;font-size:16px"
                ><b>{{ this.CaseWorkerLists.length }}</b></span
              >
              <button class="ts-btn ts-btn-small" @click="goBack">Back</button>
              <button
                class="ts-btn ts-btn-small"
                @click="manageAssignedCaseworkers"
              >
                Confirm Staff
                <span class="req-notif">
                  {{ this.caseworkerToManage.length }}</span
                >
              </button>
            </div>
          </el-col>
        </el-row>
      </div>
      <p>
        See and manage your connected Career Centers as well as your assigned
        staff.
      </p>
      &nbsp;
      <div class="ts-app-landing-dashboard">
        <div>
          <el-table
            ref="multipleTable"
            :data="this.CaseWorkerLists"
            stripe
            :height="tableHeight"
            style="width:100%; margin-top:-20px"
            :header-cell-style="{textAlign: 'center'}"
            v-if="!showNoData"
          >
            <el-table-column label width="60">
              <template slot-scope="scope">
                <img
                  style="height: 35px;"
                  v-bind:src="
                    `https://ui-avatars.com/api/?name=${scope.row.caseWorkerName}&background=00C8DC&color=fff&rounded=true`
                  "
                />
              </template>
            </el-table-column>
            <el-table-column
              sortable
              property="caseWorkerName"
              label="Staff Name"
              width="200"
              :align="'center'"
            >
            </el-table-column>
            <el-table-column
              sortable
              property="email"
              label="Email"
              width="250"
              :align="'center'"
            >
            </el-table-column>
            <el-table-column
              sortable
              property="agencyName"
              label="Career Center Name"
              width="200"
              :align="'center'"
            >
            </el-table-column>
            <el-table-column
              property="zipCode"
              width="110"
              show-overflow-tooltip
              sortable
              :align="'center'"
            >
              <template slot="header">
                <span>Career Center</span><br>
                <span>Zip Code</span>
              </template>
            </el-table-column>
            <el-table-column width="155" sortable :align="'center'">
              <template slot-scope="scope">
                <span>{{ scope.row.numberOfDaysConnected }} Days</span>
              </template>
              <template slot="header">
                <span>Days</span><br>
                <span>Connected</span>
              </template>
            </el-table-column>
            <el-table-column width="200" :align="'left'">
              <template slot-scope="scope">
                <button
                  class="ts-btn ts-btn-small ts-btn-secondary"
                  @click.prevent="editConnection(scope.$index, scope.row)"
                >
                  Edit Connection
                </button>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-dialog
            title=""
            :visible="showEditDialog"
            :show-close="false"
            width="750px"
            class="ts-modal"
          >
            <button
              type="button"
              aria-label="Close"
              class="el-dialog__headerbtn"
              @click="onCloseDialog(null)"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>

            <h6 style="text-align: left; word-break: break-word;">
              Please select which connection you want to manage
            </h6>
            <p style="text-align: left;padding-bottom: 5px;">
              Please select if you want to be reassigned to a new staff, or if
              you want to remove the entire Career Center connection.
            </p>
            <p style="text-align: left;padding-bottom: 5px;">
              Choose option below
            </p>
            <el-radio-group v-model="RemoveType" @change="toggleRemoveType">
              <el-radio-button label="Remove Career Center"></el-radio-button>
              <el-radio-button label="Reassign Staff"></el-radio-button>
            </el-radio-group>
            <br />
            <br />
            <div v-if="showRemoveCareerCenter">
              <el-form>
                <p style="text-align: left;padding-bottom: 5px;">
                  Please select reason why you want to remove this Career Center:
                </p>

                <el-form-item
                    :required="true"
                    :error="retrieveFieldError(modelState, 'careerCenterLeaveReason')"
                  >

                <el-radio
                  v-model="careerCenterLeaveReason"
                  label="Got a Job"
                  border
                  @change="changeReasonSelection"
                  >Got a Job</el-radio
                >
                <el-radio
                  v-model="careerCenterLeaveReason"
                  label="Left Career Center"
                  border
                  @change="changeReasonSelection"
                  >Left Career Center</el-radio
                >
                <el-radio
                  v-model="careerCenterLeaveReason"
                  label="Others"
                  border
                  @change="changeReasonSelectionOther"
                  >Others</el-radio
                >
                </el-form-item>
                <br>
                <br>
                <el-form-item
                  :required="true"
                  :error="retrieveFieldError(modelState, 'careerCenterLeaveReasonOther')"
                >
                  <el-input
                    v-if="showCareerCenterOther"
                    v-model="careerCenterLeaveReasonOther"
                    type="textarea"
                    :rows="5"
                    style="width: 500px"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div v-if="showRemoveTypeCaseworkers">
              <el-alert
                title="Removing this staff will notify the Career Center that they need to reassign you a new staff."
                type="warning"
                :closable="false"
                show-icon
              >
              </el-alert>
              <p style="text-align: left;padding-bottom: 5px;">
                Please select reason why you want to be reassigned to a new
                staff:
              </p>
              <el-radio
                v-model="caseworkerremovereason"
                label="0"
                border
                @change="togglecaseworkerremovereason"
                >Program Termination</el-radio
              >
              <el-radio
                v-model="caseworkerremovereason"
                label="1"
                border
                @change="togglecaseworkerremovereason"
                >Employment</el-radio
              >
              <el-radio
                v-model="caseworkerremovereason"
                label="2"
                border
                @change="togglecaseworkerremovereason"
                >Relocation</el-radio
              >
              <el-radio
                v-model="caseworkerremovereason"
                label="3"
                border
                @change="togglecaseworkerremovereason"
                >Other</el-radio
              >
              <p
                v-if="showcaseworkerremovereasondetail"
                style="text-align: left;padding-bottom: 5px;"
              >
                Please explain the reason why you want to be reassigned to a new
                staff
              </p>
              <el-input
                v-if="showcaseworkerremovereasondetail"
                v-model="caseworkerremovereasondetail"
                type="textarea"
                :rows="5"
                style="width: 500px"
              />
            </div>
            <div class="ts-modal_actions" style="padding-top:30px;">
              <button
                class="ts-btn ts-btn-white ts-btn-small"
                @click="onCloseDialog(null)"
              >
                Cancel
              </button>

              <button
                  :disabled="RemoveType == null"
                  class="ts-btn ts-btn-small"
                  @click="confirmEditConnection"
                >
                  Confirm
                </button>
            </div>
          </el-dialog>
          <el-dialog
            title="Manage Staff that Career Centers Have Assigned"
            :visible="showAssignedCaseworkersDialog"
            :show-close="false"
            width="900px"
            class="ts-modal"
          >
            <button
              type="button"
              aria-label="Close"
              class="el-dialog__headerbtn"
              @click="closeAssignedCaseworkers(null)"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>

            <p style="text-align: left;padding-bottom: 5px;">
              From here, you will be able to manage the staff that Career
              Centers have proposed to assign to you. You can either confirm or
              decline them.<br />
              Also send reminders to the Career Centers who you are connected
              with but not yet been assigned a staff.
            </p>
            <el-table
              ref="multipleTable"
              :data="this.PendingCaseworkerList"
              stripe
              height="265"
              style="width:100%; margin-top:-20px"
              v-if="!showNoData"
            >
              <el-table-column
                sortable
                property="agencyName"
                label="Career Center Name"
                width="200"
              >
              </el-table-column>
              <el-table-column
                sortable
                property="caseWorkerName"
                label="Staff Name"
                width="200"
              >
              </el-table-column>
              <el-table-column
                sortable
                property="email"
                label="Email"
                width="150"
              >
              </el-table-column>
              <el-table-column width="200">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.caseWorkerName !== '-'" class="">
                      <el-tooltip content="Decline" placement="top">
                        <button
                          class="ts-btn ts-btn-small"
                          @click.prevent="
                            declineCaseWorker(scope.$index, scope.row)
                          "
                          style="float: left"
                        >
                          Decline
                        </button>
                      </el-tooltip>

                      <el-tooltip content="Confirm" placement="top">
                        <button
                          class="ts-btn ts-btn-small"
                          @click.prevent="
                            confirmCaseWorker(scope.$index, scope.row)
                          "
                          style="float: left; margin-left: 10px;"
                        >
                          Confirm
                        </button>
                      </el-tooltip>
                    </div>

                    <div v-else class="">
                      <el-tooltip content="Send Reminder" placement="top">
                        <button
                          class="ts-btn ts-btn-small"
                          style="width:165px"
                          @click.prevent="
                            sendReminderToCaseWorker(scope.$index, scope.row)
                          "
                        >
                          Send Reminder
                        </button>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="100">
                <template slot-scope="scope">
                  <el-tooltip content="Remove" placement="top">
                    <el-button
                      class="ts-btn-small invt-action"
                      @click.prevent="
                        deleteConfirmCaseWorker(scope.$index, scope.row)
                      "
                    >
                      <i class="fas fa-trash-alt"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div class="ts-modal_actions">
              <button
                class="ts-btn ts-btn-white ts-btn-small"
                @click="closeAssignedCaseworkers(null)"
              >
                Cancel
              </button>
            </div>
          </el-dialog>

          <TSLoading
            :active="isLoading"
            :defaultMessage="'Please wait...'"
            :altMessage="
              'Please hold on for a moment while we process the data...'
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("jobseeker/getconnnectedcaseworkers").then(res => {
      this.caseworkerToManage = res.filter(r => r.status != "Completed");
      this.CaseWorkerLists = res.filter(r => r.status == "Completed");
      this.calculateHeight();
      this.isLoading = false;
    });
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    }
  },
  data() {
    return {
      isLoading: false,
      caseworkerToManage: [],
      CaseWorkerLists: [],
      showNoData: false,
      showEditDialog: false,
      RemoveType: null,
      caseworkerremovereason: null,
      careerCenterLeaveReason: null,
      careerCenterLeaveReasonOther: null,
      caseworkerremovereasondetail: null,
      showCareerCenterOther: false,
      showRemoveTypeCaseworkers: false,
      showRemoveCareerCenter: false,
      showcaseworkerremovereasondetail: false,
      deleteData: null,
      showAssignedCaseworkersDialog: false,
      PendingCaseworkerList: [],
      tableHeight: "500",
      modelState: {},
    };
  },
  methods: {
    editConnection(index, row) {
      this.deleteData = row;
      this.showEditDialog = true;
      this.careerCenterLeaveReason = null;
      this.showRemoveCareerCenter = false;
    },
    onCloseDialog() {
      this.RemoveType = null;
      this.showRemoveTypeCaseworkers = false;
      this.caseworkerremovereason = null;
      this.caseworkerremovereasondetail = null;
      this.showcaseworkerremovereasondetail = false;
      this.showEditDialog = false;
    },
    confirmEditConnection() {
      if (this.RemoveType == "Remove Career Center") {
        this.modelState = {};
        if (this.careerCenterLeaveReason === null || this.careerCenterLeaveReason === "") {
          this.modelState = { careerCenterLeaveReason: ["Reason selection is required."] };
          return;
        }

        if (this.careerCenterLeaveReason === "Others" && (this.careerCenterLeaveReasonOther === null || this.careerCenterLeaveReasonOther === "")) {
          this.modelState = { careerCenterLeaveReasonOther: ["The reason field is required."] };
          return;          
        }
        this.$confirm(
          "Removing the Career Center will also remove the assigned staff and notify the Career Center that they have been removed.<br/><br/>Are you sure you want to remove the Career Center? ",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        )
          .then(() => {
            this.isLoading = true;
            this.$store
              .dispatch(
                "jobseeker/removeCareerCenterConnectionrequest",
                { inviteId: this.deleteData.inviteId, reason: this.careerCenterLeaveReason, details: this.careerCenterLeaveReasonOther }
              )
              .then(res => {
                if (res) {
                  this.$store
                    .dispatch("jobseeker/getconnnectedcaseworkers")
                    .then(res => {
                      this.caseworkerToManage = res.filter(
                        r => r.status != "Completed"
                      );
                      this.CaseWorkerLists = res.filter(
                        r => r.status == "Completed"
                      );
                      this.onCloseDialog();
                      this.calculateHeight();
                      this.isLoading = false;
                    });
                }
              });
          })
          .catch(() => {});
      } else if (this.RemoveType == "Reassign Staff") {
        this.$confirm(
          "This request will notify the Career Center and subject for approval.<br/><br/> Are you sure you want to be reassigned to a new staff?",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        )
          .then(() => {
            this.isLoading = true;
            var request = {};
            request.InviteId = this.deleteData.inviteId;
            request.Recipient = this.deleteData.email;
            request.UserId = this.currentUser.id;
            request.JobseekerEmail = this.currentUser.email;
            request.JobseekerName = this.currentUser.fullName;
            request.JobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
            request.RequestReason = this.caseworkerremovereasondetail;

            this.$store
              .dispatch("jobseeker/createJobseekerReassignRequest", request)
              .then(res => {
                if (res) {
                  this.$message.success("Reassign staff request sent.");
                  this.$store
                    .dispatch("jobseeker/getconnnectedcaseworkers")
                    .then(res => {
                      this.caseworkerToManage = res.filter(
                        r => r.status != "Completed"
                      );
                      this.CaseWorkerLists = res.filter(
                        r => r.status == "Completed"
                      );
                      this.calculateHeight();
                      this.isLoading = false;
                      this.onCloseDialog();
                    });
                } else {
                  this.$message.error("You already have an existing request.");
                  this.isLoading = false;
                }
              });
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.$message.error(
          "Please select which connection you want to remove."
        );
      }
    },
    toggleRemoveType() {
      this.caseworkerremovereasondetail = null;
      this.modelState = {};

      if (this.RemoveType == "Reassign Staff") {
        this.showRemoveTypeCaseworkers = true;
        this.showRemoveCareerCenter = false;
        this.showCareerCenterOther = false;     
      }
      else if (this.RemoveType == "Remove Career Center") {
        this.showRemoveCareerCenter = true;
        this.showRemoveTypeCaseworkers = false;
        this.caseworkerremovereason = null;
        this.caseworkerremovereasondetail = null;
        this.showcaseworkerremovereasondetail = false;
        this.careerCenterLeaveReason = null;
      }
    },
    togglecaseworkerremovereason() {
      this.caseworkerremovereasondetail = null;

      if (this.caseworkerremovereason == "3") {
        this.showcaseworkerremovereasondetail = true;
      } else {
        this.showcaseworkerremovereasondetail = false;
      }

      if (this.caseworkerremovereason == "0") {
        this.caseworkerremovereasondetail = "Program Termination";
      } else if (this.caseworkerremovereason == "1") {
        this.caseworkerremovereasondetail = "Employment";
      } else if (this.caseworkerremovereason == "2") {
        this.caseworkerremovereasondetail = "Relocation";
      }
    },
    manageAssignedCaseworkers() {
      this.isLoading = true;
      this.showAssignedCaseworkersDialog = true;
      this.$store
        .dispatch("jobseeker/getconnnectedcaseworkers")
        .then(res => {
          this.caseworkerToManage = res.filter(r => r.status != "Completed");
          this.PendingCaseworkerList = res
            .filter(r => r.status == "Pending Staff")
            .filter(r => r.caseWorkerName != null);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeAssignedCaseworkers() {
      this.showAssignedCaseworkersDialog = false;
      this.$store.dispatch("jobseeker/getconnnectedcaseworkers").then(res => {
        this.caseworkerToManage = res.filter(r => r.status != "Completed");
        this.CaseWorkerLists = res.filter(r => r.status == "Completed");
        this.calculateHeight();
      });
    },
    declineCaseWorker(index, row) {
      this.$confirm(
        "Declining this staff will notify the Career Center that they need to reassign you a new staff. <br/><br/>Are you sure you want to decline your assigned staff?",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.isLoading = true;
          this.$store
            .dispatch("jobseeker/deletemycaseworkerassigned", row.inviteId)
            .then(res => {
              this.$store
                .dispatch("jobseeker/getconnnectedcaseworkers")
                .then(res => {
                  this.caseworkerToManage = res.filter(
                    r => r.status != "Completed"
                  );
                  this.PendingCaseworkerList = res
                    .filter(r => r.status == "Pending Staff")
                    .filter(r => r.caseWorkerName != null);
                });
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {});
    },
    confirmCaseWorker(index, row) {
      this.$confirm(
        "By accepting this request, you are confirming the connection to this Career Center, " +
          row.agencyName +
          ".<br/><br/> Do you want to continue?",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.isLoading = true;
          var obj = {
            ConnectionRequestId: row.inviteId,
            JobSeekerId: this.$store.state.account.current_user.id,
            Fullname: this.$store.state.account.current_user.fullName
          };
          this.$store
            .dispatch("jobseeker/acceptagencyconnectionrequest", obj)
            .then(res => {
              this.$store
                .dispatch("jobseeker/getconnnectedcaseworkers")
                .then(res => {
                  this.caseworkerToManage = res.filter(
                    r => r.status != "Completed"
                  );
                  this.PendingCaseworkerList = res
                    .filter(r => r.status == "Pending Staff")
                    .filter(r => r.caseWorkerName != null);
                });
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .finally(() => {});
    },
    deleteConfirmCaseWorker(index, row) {
      this.$confirm(
        "Are you sure you want to remove this Career Center connection?<br/><br/>This will notify the Career Center and connection will be removed permanently.",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.isLoading = true;
          this.$store
            .dispatch("jobseeker/declineagencyconnectionrequest", row.inviteId)
            .then(res => {
              if (res) {
                this.$store
                  .dispatch("jobseeker/getconnnectedcaseworkers")
                  .then(res => {
                    this.caseworkerToManage = res.filter(
                      r => r.status != "Completed"
                    );
                    this.PendingCaseworkerList = res
                      .filter(r => r.status == "Pending Staff")
                      .filter(r => r.caseWorkerName != null);
                  });
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {});
    },
    goBack() {
      this.$router.push({ name: "agency-dashboard" });
    },
    calculateHeight() {
      this.tableHeight = this.$refs["container"].clientHeight - 130;
    },
    sendReminderToCaseWorker(index, row) {
      this.$store
        .dispatch("jobseeker/sendReminderReassignRequest", row)
        .then(res => {
          if (res) this.$message.success("Reminder is sent!");
        });
    },
    changeReasonSelection() {
      this.showCareerCenterOther = false;      
      this.modelState = {};
    },
    changeReasonSelectionOther () {
      this.showCareerCenterOther = true;      
      this.modelState = {};
    },
  }
};
</script>
<style lang="scss">
.section-title {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  background-color: #e8edf3;
  padding-bottom: 5px;
  margin-bottom: 10px !important;
}

.req-notif {
  color: white !important;
  border: 1px solid #d30606 !important;
  background-color: #d30606 !important;
  border-radius: 10px !important;
  width: 20px !important;
  display: inline-block !important;
  text-align: center !important;
  font-size: 12px !important;
  line-height: 12px !important;
  margin-left: 10px;
}

.mobile-menu .el-dropdown {
  display: none !important;
}

@media screen and (max-width: 759px) {
  .ts-app-shell--header_actions .ts-btn {
    display: none !important;
  }

  .mobile-menu .el-dropdown {
    display: inherit !important;
  }

  .el-radio.is-bordered {
    width: 100% !important;
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0px !important;
  }

  .ts-modal textarea {
    width: 60% !important;
  }

  .el-radio-button__inner {
    border-left: 1px solid #dcdee2 !important;
  }
}
</style>
